import React from "react";
import logo from "../assets/ccmi_logo.webp";
import { Link, useLocation } from "react-router-dom";
import ColourBar from "../components/ColourBar";
import auth from "../api/auth";

const FooterContainer = () => {

    const location = useLocation();
    const currentPath = location.pathname;

    const showShortFaq = ["/faq", "/pricing-plans", "/get-in-touch"].includes(currentPath);

    return (
        <div className="footer">
            <ColourBar height={6}/>
            <div className="footer-container">
                <div className="footer-nav-container">
                    <div className="footer-logo">
                        <img src={logo} alt="Logo"/>
                    </div>
                    <div className="footer-links">
                        <Link to="/privacy" >Privacy Policy</Link>
                        {!auth.isAuthenticated ? (
                            <Link to={`/faq?shortfaq=${showShortFaq ? "true" : "false"}`}>FAQ's</Link>
                        ) : null}
                        <Link to="/settings?preferences=true">Newsletter</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterContainer;